import React, { useState } from 'react';
import HorizontalBarCard from '../../../HOC/Cards/HorizontalBar';
import { parseGuest } from 'src/utils/functions';
import { GRAPH_BLUE } from 'src/colors';

const TopCitiesCard = ({
  graph,
  isDisabled,
  handleOnSampleClick,
  matches,
  userTailorMarketAccess,
}: {
  graph;
  isDisabled: boolean;
  handleOnSampleClick: any;
  matches: boolean;
  userTailorMarketAccess: boolean;
}) => {
  const GRAPH_LIMIT = 5;
  const [graphLimit, setGraphLimit] = useState<number>(GRAPH_LIMIT);
  const dummyData = {
    London: 21.1,
    Brighton: 3.8,
    Bristol: 1.5,
    Reading: 1.2,
    Manchester: 1.1,
    Portsmouth: 0.9,
    Bournemouth: 0.8,
    Birmingham: 0.7,
    Cambridge: 0.7,
    Paris: 0.7,
  };

  const onCTAClick = () => {
    setGraphLimit(prevLimit => (prevLimit === GRAPH_LIMIT ? -1 : GRAPH_LIMIT));
  };

  return (
    <>
      <HorizontalBarCard
        title="By Guest's Origin Cities"
        data={isDisabled ? dummyData : parseGuest(graph.data?.guest.cities)}
        color={GRAPH_BLUE}
        unit="%"
        isDisabled={isDisabled}
        handleOnSampleClick={handleOnSampleClick}
        graphLimit={graphLimit}
        onCTAClick={onCTAClick}
        matches={matches}
        userTailorMarketAccess={userTailorMarketAccess}
      />
    </>
  );
};

export default TopCitiesCard;
